import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const forgejo = defineConnector({
  identifier: "forgejo",
  name: "Forgejo",
  tagLine: "Self-hosted Git platform",
  logo,
  protocol: "http",
  tags: ["engineering"],
  defaultUrlPattern: ({ host }) =>
    host
      ? `https://${host.replace(/\./g, "\\.")}/.*`
      : "https://.*\\.forgejo\\.org/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Get an access token",
      items: [
        {
          kind: "markdown",
          content:
            "Visit your Forgejo instance **Settings > Applications** and generate a new personal access token.",
        },
      ],
    },
    {
      title: "Enter your instance URL",
      items: [
        {
          kind: "input",
          label: "Forgejo host",
          placeholder: "forgejo.example.com",
          required: true,
          target: { kind: "configuration", field: "host" },
        },
      ],
    },
    {
      title: "Copy and paste the token into the field below",
      items: [
        {
          kind: "input",
          label: "Access token",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ host }) => `https://${host}/api/v1/user`,
  },
});
